export default __webpack_public_path__ + "static/media/gallery-4.b75814f6.jpg";